import React from 'react'
import AccountCell from './AccountCell'
import StatusBadge from './StatusBadge'
import { WAITING_COLUMNS, exactTime, relativeTime, reportTypeLabel } from './waitingListConstants'

export default function WaitingListRow({ row, position, onNavigate }) {
  const isRetrying = row.status === 'retrying'

  return (
    <div className="flex items-center gap-4 px-4 py-2 border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter last:border-b-0 hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter transition-colors">
      <span className={`${WAITING_COLUMNS.position} text-xs tabular-nums text-rb-mat-grey dark:text-rb-dark-mode-text-grey`}>
        {position}
      </span>
      <AccountCell row={row} className={WAITING_COLUMNS.account} onNavigate={onNavigate} />
      <span className={`${WAITING_COLUMNS.email} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`} title={row.email || ''}>
        {row.email || '–'}
      </span>
      <span className={`${WAITING_COLUMNS.type} text-sm text-rb-black dark:text-white truncate`}>
        {reportTypeLabel(row)}
      </span>
      <span className={`${WAITING_COLUMNS.requestedBy} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`}>
        {row.requested_by || 'System'}
      </span>
      <span className={`${WAITING_COLUMNS.queued} text-sm text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate`} title={exactTime(row.created_at)}>
        {relativeTime(row.created_at)}
      </span>
      <span className={WAITING_COLUMNS.status}>
        <StatusBadge
          status={row.status}
          title={isRetrying ? `Last error (${exactTime(row.last_attempted_at)}): ${row.last_error || 'unknown'}` : undefined}
        >
          {isRetrying ? `Retry ${row.attempts}/${row.max_attempts}` : undefined}
        </StatusBadge>
      </span>
    </div>
  )
}
